export const APP_NAME = 'Talentchek';
export const APP_VERSION = '1.0.0';

export const PAGINATION_DEFAULT_PAGE = 1;
export const PAGINATION_DEFAULT_LIMIT = 20;

export const TOKEN_KEY = 'tc_access_token';
export const REFRESH_TOKEN_KEY = 'tc_refresh_token';
export const USER_KEY = 'tc_user';
export const THEME_KEY = 'tc_theme';
export const LOCALE_KEY = 'tc_locale';
export const V2_USER_KEY = 'tc_v2_user';
export const USER_PROFILE_KEY = 'tc_user_profile';
export const USER_AUTHORITY_KEY = 'tc_user_authority';

export const SUPPORTED_LOCALES = ['en', 'fr', 'es', 'ar'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DATE_FORMAT = 'DD MMM YYYY';
export const DATETIME_FORMAT = 'DD MMM YYYY, HH:mm';

export const MAX_FILE_SIZE_MB = 10;
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/svg+xml'];
export const ALLOWED_DOCUMENT_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const QUERY_STALE_TIME = 5 * 60 * 1000; // 5 minutes
export const QUERY_CACHE_TIME = 10 * 60 * 1000; // 10 minutes

export const DEBOUNCE_DELAY = 300; // ms

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE: 422,
  SERVER_ERROR: 500,
} as const;
